"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandThemeMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class BrandThemeMapper {
    toDomain(result) {
        const application_id = result.application_id;
        const updated_at = new Date(result.application_id);
        const created_at = new Date(result.application_id);
        const name = lodash_1.default.get(result, "data[0].name");
        const configuration = lodash_1.default.get(result, "data[0].configuration");
        return {
            application_id,
            updated_at,
            created_at,
            data: Object.assign({ name }, configuration),
        };
    }
}
exports.BrandThemeMapper = BrandThemeMapper;
